<template>
    <div style="width: 100%;">
        <!-- top -->
        <div class="for_top">
            <div>
                <img src="../../../../assets/purchase/image/index/right.png" alt="">
            </div>
            <div class="for_you">为你推荐</div>
            <div>
                <img src="../../../../assets/purchase/image/index/left.png" alt="">
            </div>
        </div>
        <!-- center -->
        <div class="for_center" >
            <div class="for_center_main" v-for="(item,index) in for_you_list" :key="index" @click="myOrderup(item.cat_id,index)" >
                <div  :class="[text == index?  'for_center_fonts' : 'for_center_font']">
                    <span class="fonts">{{item.name}}</span>
                </div>
                <div :class="[text == index?  'for_center_contents' : 'for_center_content']" >{{item.introduce}}</div>
            </div>
        </div>
        <!-- bottom -->
        <div class="floor-content" v-if="this.forlist.length!=0">
          <div class="list"  v-for="(value,key,index) in forlist" :key='index'>
            <div class="item">
              <span @click="qylist(value.id)" style="position: relative;">
                <img class="item-img"
                     v-lazy="value.cover_pic"
                     :onerror="errorImg" />
                <img src="../../../../assets/purchase/image/index/baokuan.png" v-if="value.is_hot==1" alt="" class="baokuanImg">
                <div class="name show-two-lines"
                     v-text="value.name"></div>
                <div class="pic">
                    <div class="pic_font">￥<span class="pic_fonts">{{Math.trunc(value.price)}}.</span><span class="pic_font">{{value.price.split('.')[1]}}</span></div>
                    <div class="pic_jdfont">京东￥{{value.jd_price}}</div>
                </div>
              </span>
            </div>
          </div>
          <div class="list"></div>
          <div class="list"></div>
          <div class="list"></div>
        </div>
        <div v-else class="bottom">
            <img src="../../../../assets/purchase/image/index/emty.png" alt="" style="" class="elseimg">
            <div>小二正在进货中....</div>
        </div>
    </div>
    
</template>
<script>
export default {
  props: {
    for_you_list:{
      type: Array,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
        forlist:[],
        route_url: this.$route.params.route_url,
        text:"",
      errorImg:
        'this.src="' + require('../../../../assets/images/lodingsb.svg') + '"' //图片加载失败
    }
  },
  watch: {
    floor_list: function(newValue) {
    }
  },
  mounted(){
    this.myOrderup(this.for_you_list[0].cat_id,0)
    console.log(this.for_you_list[0].cat_id,"1")
  },

  methods: {
    myOrderup(i,index){
        this.text = index
        this.$api
        .goodList({
            cat_id: i,
            access_token: this.$store.state.qycg_user.access_token,
        })
        .then(res => {
          if (res.code == 0) {
            this.forlist=res.data
          }
        })
        .catch(err => {
          this.common.message(this, err)
        })

    },
    qylist(id) {
      let url = this.$router.resolve({
        path: this.common.qycgrouter(this) + '/qycgdetails',
        query: {
          id: id
        }
      })
      // console.log(this.common.qycgrouter(this))
      // console.log(url)
      window.open(url.href)
    }
    // floorTab(index) {
    // 	this.param.active_index = index;
    // }
  }
}
</script>
<style lang="scss" scoped>
.bottom{
    width: 100px;
    margin: auto;
    margin-top: 214px;
    .elseimg{
    width: 100px;
    height: 100px;
}
}

.for_top{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .for_you{
        font-weight: 500;
        color: #333333;
        font-size: 26px;
        margin: 0 16px;
    }
    img{
        width: 24px;
        height: 26px;
    }
}
.for_center{
    width: 100%;
    display: flex;
    justify-content: space-around;
    background: #FFFFFF;
    margin-top: 20px;
    .for_center_main {
        padding: 10px 0;
        // margin:  0 15px;
        .for_center_font{
            // width: 88px;
            cursor:pointer;
            height: 28px;
            text-align: center;
            font-size: 16px;
            font-weight: 800;
            color: #333333;
            .font{
                line-height:28px;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
            }
        }
        .for_center_fonts{
            // height: 28px;
            cursor:pointer;
            background: #CC0000;
            border-radius: 14px;
            padding: 3px 5px;
            margin-bottom: 5px;
            text-align: center;
            .fonts{
                font-weight: 500;
                font-size: 12px;
                color: #ffffff;
               
            }
        }
        .for_center_content{
            cursor:pointer;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
            text-align: center;
        }
        .for_center_contents{
            cursor:pointer;
          font-size: 14px;
          font-weight: 400;
          color: #CC0000;
          line-height: 20px;
          text-align: center;
      }
    }
}
.floor-box {
  margin-top: 20px;
}
.floor-title {
  padding: 17px 0 7px;
  h4 {
    font-weight: 500;
    font-size: 28px;
    color: #333333;
    line-height: 28px;
  }
  ul {
    li {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      margin-left: 24px;
      transition: color 0.3s;
      cursor: pointer;
    }
    li:hover,
    li.active {
      color: #ff0e25;
      font-weight: 500;
    }
    li:first-child {
      margin-left: 0;
    }
  }
}
.floor-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
   
  .advert {
    margin-top: 10px;
    width: 250px;
    height: 590px;
    background: #cccccc;
    cursor: pointer;
    overflow: hidden;
    img {
      width: 100%;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
    }
    img:hover {
      transform: scale(1.1);
    }
  }
  .list {
    // width: 940px;
    width: 220px;
    // display: flex;
    // flex-wrap: wrap;
    .item {
      cursor: pointer;
      width: 220px;
      height: 290px;
      background-color: #fff;
      margin: 10px 16px 0 0px;
      padding: 15px;
      box-sizing: border-box;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      &:nth-child(5n) {
        margin-right: 0;
      }
      &:hover {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      }

      .item-img {
        width: 150px;
        height: 150px;
        margin: 0 auto;
      }
      .baokuanImg{
        width: 34px;
        height: 32px;
        position: absolute;
        top:0px;
        right: 5px;
    }

      .pic {
      
        display: flex;
        margin-top: 10px;
        text-align: center;
        .pic_font{
            font-weight: 822;
            color: #CC0000;
            font-size: 14px;
            margin-right: 16px;
            .pic_fonts{
                color: #CC0000;
                font-size: 20px;
            }
        }
        .pic_jdfont{
            font-weight: 500;
            color: #333333;
            font-size: 12px;
            margin-top: 5px;
            text-decoration: line-through;
        }
      }

      .name {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
        height: 36px;
        margin-top: 24px;
        text-align: center;
      }

      .label {
        margin-top: 8px;
        max-height: 44px;
        overflow: hidden;
        span {
          min-width: 32px;
          padding: 0px 4px;
          border-radius: 3px;
          border: 1px solid #ff0e25;
          box-sizing: border-box;
          display: inline-block;
          color: #ff0e25;
          margin: 0 4px 4px 0;
        }
      }
    }
  }
}
</style>